import { render, staticRenderFns } from "./QuestionLibDialog.vue?vue&type=template&id=2dffff5c&scoped=true"
import script from "./QuestionLibDialog.vue?vue&type=script&lang=ts"
export * from "./QuestionLibDialog.vue?vue&type=script&lang=ts"
import style0 from "./QuestionLibDialog.vue?vue&type=style&index=0&id=2dffff5c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dffff5c",
  null
  
)

export default component.exports